<template src="./StudentLogin.html"></template>

<script>
const EMAIL_PATTERN = /.+@.+\..+/;

export default {
  name: "StudentLogin",

  props: {
    instituteLogo: { type: String, default: "" },
    formType: { type: String, default: "" },
    formTitle: { type: String, default: "" },
    semName: { type: String, default: "" },
    department: { type: String, default: "" },
    batch: { type: String, default: "" },
    courseYear: { type: String, default: "" },
    subjectCount: { type: Number, default: 0 },
    dueDate: { type: String, default: "" },
    loading: { type: Boolean, default: false },
  },

  data: () => ({
    prn: "",
    email: "",
    touched: { prn: false, email: false },
  }),

  computed: {
    // Program Exit Survey (PO feedback) is not tied to a department / course year /
    // semester, so those chips are meaningless there.
    isProgramFeedback() {
      return this.formType === "Program Feedback";
    },

    // Recruiters have no PRN, so the PRN field is hidden and not required.
    isRecruiterFeedback() {
      return this.formType === "Recruiter Feedback";
    },

    chips() {
      const values = this.isProgramFeedback
        ? [this.batch]
        : [this.batch, this.department, this.semName, this.courseYear];
      return values.filter(Boolean);
    },

    errors() {
      return {
        prn: this.isRecruiterFeedback || this.prn ? "" : "PRN is required",
        email: !this.email
          ? "Email is required"
          : EMAIL_PATTERN.test(this.email)
          ? ""
          : "Email must be valid",
      };
    },

    isValid() {
      return !this.errors.prn && !this.errors.email;
    },
  },

  methods: {
    showError(field) {
      return this.touched[field] && !!this.errors[field];
    },

    fieldClass(field) {
      if (this.showError(field)) return "login__field--invalid";
      if (!this.errors[field]) return "login__field--active";
      return "";
    },

    onSubmit() {
      this.touched.prn = true;
      this.touched.email = true;
      if (!this.isValid || this.loading) return;
      this.$emit("submit", { prn: this.prn, email: this.email });
    },
  },
};
</script>

<style src="./StudentLogin.css" scoped></style>
